module.exports = __webpack_public_path__ + "static/media/icon-age.da85da22.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-age.svg
// module id = 269
// module chunks = 0